import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialShare1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M20.565 9.14h1.53v1.53h4.57V9.14h1.52V7.62h-1.52V4.57h-1.53V3.05h1.53v1.52h1.52v3.05h1.53V3.05h-1.53V1.52h-1.52V0h-4.57v1.52h-1.53v1.53h-1.52v4.57h1.52zm-1.52 19.81h1.52v1.53h1.53V32h4.57v-1.52h1.52v-1.53h-1.52V25.9h-1.53v-1.52h1.53v1.52h1.52v3.05h1.53v-4.57h-1.53v-1.52h-1.52v-1.53h-4.57v1.53h-1.53v1.52h-1.52zm-1.52-6.09h1.52v1.52h-1.52Zm0-15.24h1.52v1.52h-1.52Zm-1.53 13.71h1.53v1.53h-1.53Zm0-12.19h1.53v1.53h-1.53Zm-1.52 10.67h1.52v1.52h-1.52Zm0-9.14h1.52v1.52h-1.52Zm-1.53 7.62h1.53v1.52h-1.53Zm0-6.1h1.53v1.52h-1.53Zm-7.61-1.52v1.52h-1.53v1.52h-1.52v4.58h1.52v1.52h1.53v1.52h4.57v-1.52h1.52v-1.52h1.52v-4.58h-1.52v-1.52h-1.52v-1.52z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialShare1
